// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1_sign_method.ml",
      58,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "SignMethod"
                    ]]
                },
                "V1"
              ]]
          },
          "$$Document"
        ]]
    });

const $$Document = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1_sign_method.ml",
      81,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "SignMethod"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1_sign_method.ml",
      102,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "SignMethod"
        ]]
    });

const SignMethod = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_document_v1_sign_method.ml",
      121,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.document.v1.SignMethod";
}

function to_int(param) {
  switch (param) {
    case /* SIGN_METHOD_UNSPECIFIED */0 :
        return 0;
    case /* SIGN_METHOD_XML_RAW */1 :
        return 10;
    case /* SIGN_METHOD_CMS_ATTACHED */2 :
        return 30;
    case /* SIGN_METHOD_CMS_DETACHED */3 :
        return 40;
    
  }
}

function from_int_exn(n) {
  if (n >= 11) {
    if (n !== 30) {
      if (n !== 40) {
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
      } else {
        return /* SIGN_METHOD_CMS_DETACHED */3;
      }
    } else {
      return /* SIGN_METHOD_CMS_ATTACHED */2;
    }
  } else if (n !== 0) {
    if (n >= 10) {
      return /* SIGN_METHOD_XML_RAW */1;
    } else {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    }
  } else {
    return /* SIGN_METHOD_UNSPECIFIED */0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* SIGN_METHOD_UNSPECIFIED */0 :
        return "SIGN_METHOD_UNSPECIFIED";
    case /* SIGN_METHOD_XML_RAW */1 :
        return "SIGN_METHOD_XML_RAW";
    case /* SIGN_METHOD_CMS_ATTACHED */2 :
        return "SIGN_METHOD_CMS_ATTACHED";
    case /* SIGN_METHOD_CMS_DETACHED */3 :
        return "SIGN_METHOD_CMS_DETACHED";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "SIGN_METHOD_CMS_ATTACHED" :
        return /* SIGN_METHOD_CMS_ATTACHED */2;
    case "SIGN_METHOD_CMS_DETACHED" :
        return /* SIGN_METHOD_CMS_DETACHED */3;
    case "SIGN_METHOD_UNSPECIFIED" :
        return /* SIGN_METHOD_UNSPECIFIED */0;
    case "SIGN_METHOD_XML_RAW" :
        return /* SIGN_METHOD_XML_RAW */1;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, SignMethod, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "SignMethod"
        ]]
    }, V1, {
      SignMethod: SignMethod
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "SignMethod"
              ]]
          },
          "V1"
        ]]
    }, $$Document, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "SignMethod"
                    ]]
                },
                "V1"
              ]]
          },
          "$$Document"
        ]]
    }, Buhta, {
      $$Document: $$Document
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
